import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { unreadCountersSubscription } from '../../shared/data/gql/subscription/unread-counters.subscription';
import { Observable } from 'rxjs';
import { FetchResult } from 'apollo-link';
import { UnreadCountersResponse } from '../../shared/data/responses/unread-counters.response';
import { MeSubscriptionResponse } from '../../shared/data/responses/me-subscription.response';
import { getMeSubscription } from '../../shared/data/gql/subscription/getMeSubscription';

@Injectable({
  providedIn: 'root'
})
export class UserSubscriptionService {
  constructor(private apollo: Apollo) {}

  notificationSubscription(): Observable<FetchResult<UnreadCountersResponse>> {
    return this.apollo.subscribe<UnreadCountersResponse>({
      query: unreadCountersSubscription
    });
  }

  meSubscription(): Observable<FetchResult<MeSubscriptionResponse>> {
    return this.apollo.subscribe<MeSubscriptionResponse>({
      query: getMeSubscription
    });
  }
}
